export class ProjectUsersFromStringBuilderViewModel
{
    opened: boolean = false;
    operationInProgress: boolean = false;
    step: number = 1;

    tags: string[] = [];

    show(tags: string[])
    {
        this.step = 1;
        this.operationInProgress = false;
        this.tags = tags;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.step = 1;
        this.tags = [];
        this.operationInProgress = false;
    }
}